import { Injectable } from '@angular/core';
import * as moment from 'moment';

@Injectable()
export class SearchTimeService {

  constructor() { }

  chineseToDate(choice) {
    let startDate;
    let endDate;
    const currentYearStart = moment().startOf('year');
    const currentYearEnd = moment().endOf('year');
    const currentMonthStart = moment().startOf('month');
    const currentMonthEnd = moment().endOf('month');
    const currentWeekStart = moment().startOf('week');
    const currentWeekEnd = moment().endOf('week');
    const currentQuarterStart = moment().startOf('quarter');
    const currentQuarterEnd = moment().endOf('quarter');
    switch (choice) {
      case 'yesterday':
        startDate = moment().subtract(1, 'days');
        endDate = moment().subtract(1, 'days');
        break;
      case 'today':
        startDate = moment();
        endDate = moment();
        break;
      case 'tomorrow':
        startDate = moment().add(1, 'days');
        endDate = moment().add(1, 'days');
        break;
      case 'last_seven_days':
        startDate = moment().subtract(6, 'days');
        endDate = moment();
        break;
      case 'last_thirty_days':
        startDate = moment().subtract(29, 'days');
        endDate = moment();
        break;
      case 'last_week':
        startDate = moment().week(moment().week() - 1)
          .startOf('week').add(1, 'days');
        endDate = moment().week(moment().week() - 1)
          .endOf('week').add(1, 'days');
        break;
      case 'this_week':
        startDate = currentWeekStart.add(1, 'days');
        endDate = currentWeekEnd.add(1, 'days');
        break;
      case 'last_month':
        startDate = currentMonthStart.subtract(1, 'months');
        endDate = currentMonthEnd.subtract(1, 'months').endOf('month');
        break;
      case 'this_month':
        startDate = currentMonthStart;
        endDate = currentMonthEnd;
        break;
      case 'last_quarter':
        startDate = currentQuarterStart.subtract(1, 'quarters');
        endDate = currentQuarterEnd.subtract(1, 'quarters').endOf('quarter');
        break;
      case 'this_quarter':
        startDate = currentQuarterStart;
        endDate = currentQuarterEnd;
        break;
      case 'last_year':
        startDate = currentYearStart.subtract(1, 'years');
        endDate = currentYearEnd.subtract(1, 'years').endOf('year');
        break;
      case 'this_year':
        startDate = currentYearStart;
        endDate = currentYearEnd;
    }
    return {
      startDate: startDate.format('YYYY-MM-DD'),
      endDate: endDate.format('YYYY-MM-DD')
    };
  }
}
